var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Lyssna';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Lyssna';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };